export const SOFTLINE_FEATURE_PALETTEN_UMLAGERUNG = 'palettenUmlagerung';
export const SOFTLINE_PERMISSION_PALETTEN_UMLAGERUNG = 'SOFTAPPS.LAGER.PALETTEN_UMLAGERUNG';
